import React from 'react'
import CareerSection from '../../sections/CareerSection/CareerSection'
import CareerOpenings from '../../sections/CareerOpenings/CareerOpenings'

const CareerPage = () => {
  return (
    <div>
        <CareerSection/>
        <CareerOpenings/>
    </div>
  )
}

export default CareerPage